import BasicContentAccordionItem from './BasicContentAccordionItem';

export { type BasicContentAccordionItemProps } from './BasicContentAccordionItem';
export default BasicContentAccordionItem;
